import { createReactComponent } from '@tabler/icons-react';

export const IconCustomCrystalBallRibbon = createReactComponent(
  'outline',
  'customCrystalBallRibbon',
  'CustomCrystalBallRibbon',
  [
    [
      'path',
      {
        key: 'customCrystalBallRibbon-path',
        d: 'M6.73 17.018C5.5056 15.946 4.63727 14.526 4.24091 12.9476C3.84454 11.3692 3.93899 9.70744 4.51164 8.18411C5.08429 6.66078 6.10791 5.34833 7.4459 4.4219C8.78388 3.49548 10.3726 2.99915 12 2.99915C13.6274 2.99915 15.2161 3.49548 16.5541 4.4219C17.8921 5.34833 18.9157 6.66078 19.4884 8.18411C19.7684 8.92917 19.9341 9.70735 19.984 10.4927M11 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19C5 18.4696 5.21071 17.9609 5.58579 17.5858C5.96086 17.2107 6.46957 17 7 17H11M11 7C10.2044 7 9.44129 7.31607 8.87868 7.87868C8.31607 8.44129 8 9.20435 8 10M16 15H21V22L18.5 20.5L16 22V15Z',
      },
    ],
  ]
);
